/**
 * LERA Footer Premium — Sprint 8.10
 * Architecture hooks only. No sticky UI in this sprint.
 */

(function () {
  const ROOT = '[data-lera-footer-premium]';

  function boot() {
    document.querySelectorAll(ROOT).forEach((root) => {
      if (root.dataset.leraFpBooted === '1') return;
      root.dataset.leraFpBooted = '1';

      // Section D reservation — sticky slots are data-only until a future sprint.
      if (root.getAttribute('data-lera-sticky-ready') === 'true') {
        window.LeraFooterPremium = window.LeraFooterPremium || {};
        window.LeraFooterPremium.stickySlots = (root.getAttribute('data-lera-sticky-slots') || '')
          .split(',')
          .map((slot) => slot.trim())
          .filter(Boolean);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);

  window.LeraFooterPremium = window.LeraFooterPremium || {
    version: '8.10',
    refresh: boot,
    stickySlots: [],
  };
})();
